import React from 'react';
// import logo from '../../IMG/logo-panikboard.gif';
import 'CSS/Member/Login.css';
import Form from 'Components/Core/Form/Form';
import FormElement from '../Core/Form/FormElement';
import Dialog from 'Components/Core/Dialog';

export default function Login(props) {

    const x = props.x;

	const divReference = React.useRef(null);
	const [message, setMessage] = React.useState('');
	const [messageClass, setMessageClass] = React.useState('error-message');
	const wafId = props.id;
	const newMemberId = props.id + '-new-member'
	const privateMessage = (x.was.privateMessage !== '') ? <div>{x.was.privateMessage}</div> : null;
	const loginMessage = <span>Bitte melden Sie sich an.</span>;
	const projectInfo = x.was.getProjectInfo();
	x.was.setFavicon(projectInfo.srcFavicon);
	x.wam.init(props.id);
	x.waf.init(wafId, {
	});

	React.useEffect(() => {
		x.waf.mandatory(newMemberId, 'registrationCode', true);
		x.waf.mandatory(newMemberId, 'newMemberName', true);
		x.waf.mandatory(newMemberId, 'newName', true);
		x.waf.mandatory(newMemberId, 'newFirstName', true);
		x.waf.mandatory(newMemberId, 'newPassword', true);
		x.waf.mandatory(newMemberId, 'newMail', true);
		document.title = x.was.application;
	}, [x, newMemberId]);

	React.useEffect(() => {
		x.wad[props.id].show(() => { x.waf.focus('login', 'membername'); });
	});

	function onAfterLogin(data) {
		if (data.content['login'] === 1) {
			x.was.send('login', { "module": props.moduleId, "member": x.waf.get(wafId, 'membername'), "memberlevel": data.content['memberlevel'] });
			if (x.waf.get(wafId, 'autologin') === 1) {
				localStorage.setItem('token', data.content['token']);
			}
			else {
				localStorage.removeItem('token');
			}
			setTimeout(window.location.reload(), 1000);
		}
		else {
			x.waf[wafId].enableSendButton(x.waf.checkChanged(wafId));
			setMessageClass('error-message');
			setMessage('Login mit diesen Daten nicht möglich!');
		}
	}

	function showDialogNewMember() {
		x.wad[newMemberId].show(() => { x.waf.focus(newMemberId, 'registrationCode') });		
	}

	function onSubmitNewMember(event) {
		if (x.wau.validPassword(x.waf.get(newMemberId, 'newPassword'))) {
			
		}
		x.waf[newMemberId].ok(event);
	}

	function onAfterRegistration(data) {	
		setMessage(data.content.message);
		if (data.returncode === 1) {
			setMessageClass('success-message');
		}
		else {
			setMessageClass('error-message');
		}
	}
	
	const newMemberButton = <button 
								type="button" 
								key="registration" 
								className="btn " 
								onClick={showDialogNewMember}
							>Registrieren</button>

	return (
		<div id="login-frame" ref={divReference} >
			<Dialog id={props.id} x={x}   classes="login" title="Login" closeIcon={false}>

				<div id="login" className={``}>
					<div >
						<div className="logo">
						<img alt="Logo" src={projectInfo.srcLogo} />
						</div>
						<Form x={x}  
							wafId={wafId}
							module="Public"
							sendTask="Login"
							focusElement="membername"
							classes="settings-form"
							cancelButton={false}
							sendButtonTitle="Login"
							enableSendButton={true}
							buttons={[newMemberButton]}
							onAfterSend={onAfterLogin}
						>
							<FormElement x={x}   wafId={props.id} id="membername" title="Pseudonym" fieldValue="" />
							<FormElement x={x}   wafId={props.id} type="password" id="password" title="Password" fieldValue="" />
							<FormElement type="checkbox" x={x}   wafId={props.id} id="autologin" title="Automatisch anmelden" />
							<div className={`form-group ${(message !== '') ? 'd-block' : 'd-none' } ${messageClass}`} >
								<label id="login-error" >{message}</label>
							</div>
							<div className={`form-group ${(message === '') ? 'd-block' : 'd-none'}`} >
								<span className='message'>
									{loginMessage}
								</span>
							</div>
							<span className='message'>
								{privateMessage}
							</span>
						</Form>
					</div>
				</div>
			</Dialog>
			<Dialog id={newMemberId} x={x}   classes="new-member " title="Mitglied werden" >
				<Form x={x}  
					wafId={newMemberId}
					dialogId={newMemberId}
					module="Public"
					sendTask="Registration"
					focusElement="membername"
					classes="settings-form"
					cancelButton={true}
					sendButtonTitle="Registrieren"
					enableSendButton={true}
					onSubmit={onSubmitNewMember}
					onAfterSend={onAfterRegistration}
				>
					<FormElement x={x}   wafId={newMemberId} id="registrationCode" maxLength={36} title="Registrierungs-Code" fieldValue="" />
					<FormElement x={x}   wafId={newMemberId} id="newMemberName" title="Pseudonym" fieldValue="" />
					<FormElement x={x}   wafId={newMemberId} id="newName" title="Name" fieldValue="" />
					<FormElement x={x}   wafId={newMemberId} id="newFirstName" title="Vorname" fieldValue="" />
					<FormElement x={x}   wafId={newMemberId} id="newPassword" title="Das gewünschte Kennwort" fieldValue="" />
					<FormElement x={x}   wafId={newMemberId} id="newMail" title="Mail" fieldValue="" />
						<span className='new-member-message'>
							Eine Registrierung ist nur durch Empfehlung eines Mitglieds möglich. <br/>
							Dieses Mitglied wird ihnen den Registrierungs-Code nennen. <br/>
						</span>
				</Form>

			</Dialog>
		</div>
	);

}
